import React, { useState, useEffect } from 'react';
import '../../components/AddEntity/AddEntity.css';
import { useComponentLoading } from '../../utils/useComponentLoading';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';

function AddTripType({ 
    toggleFunction,
    title,
    formFields,
    apiFunction,
    onTypeChange,
    selectedType,
    onSuccess,
}) {
    const [formData, setFormData] = useState({});
    const { 
        withLoading, 
        isLoading, 
        getProgress, 
        getMessage 
    } = useComponentLoading();
    
    useEffect(() => {
        setFormData({});
    }, [formFields]);

    useEffect(() => {
        if (selectedType) {
            setFormData((prevData) => ({
                ...prevData,
                type: selectedType,
            }));
        }
    }, [selectedType]);

    const handleChange = (e) => {
        const { name, value, type, checked, multiple, selectedOptions } = e.target;

        if (type === 'checkbox') {
            setFormData({
                ...formData,
                [name]: checked,
            });
        } else if (multiple) {
            const selectedValues = Array.from(selectedOptions).map((option) => option.value);
            setFormData({
                ...formData,
                [name]: selectedValues,
            });
        } else if (type === 'datetime-local') {
            const unixTimestamp = Math.floor(new Date(value).getTime() / 1000);
            setFormData({
                ...formData,
                [name]: unixTimestamp,
            });
        } else {
            setFormData({
                ...formData,
                [name]: type === 'number' ? Number(value) : value,
            });
        }

        if (name === 'type') {
            onTypeChange(value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { hours, km, days, ...otherData } = formData;

        const meta = formData.type === 'hr-km' 
            ? { hours: hours || 0, km: km || 0 }
            : { days: days || 0, km: km || 0 };

        const payload = {
            ...otherData,
            meta,
            type: formData.type,
        };

        try {
            await withLoading('addTripType', async (onProgress) => {
                onProgress(10, 'Preparing to add trip type...');
                
                onProgress(30, 'Submitting trip type data...');
                const response = await apiFunction(payload);
                
                if (!response.ok) throw new Error(await response.text());
                
                onProgress(60, 'Processing response...');
                const result = await response.json();
                
                onProgress(90, 'Finalizing...');
                toggleFunction();
                if (onSuccess) onSuccess();
                
                onProgress(100, 'Trip type added successfully');
            }, 'Adding trip type...');
        } catch (error) {
            console.error('Error submitting form:', error);
            alert(error.message || "Failed to add trip type");
        }
    };

    if(isLoading('addTripType')){   
        return (
            <LoadingSpinner
                message={getMessage('addTripType')}
            progress={getProgress('addTripType')}
            showProgress={true}
        />
    )}

    return (
        <div className="add-form">
            <h2>{title}</h2>
            <form onSubmit={handleSubmit}>
                {formFields.map((field, index) => {
                    return (
                        <div className="form-group" key={index}>
                            <label>{field.label}:</label>
                            {field.type === 'picklist' ? (
                                <select
                                    name={field.name}
                                    required={field.required}
                                    onChange={handleChange}
                                    value={formData[field.name] || ''}
                                    disabled={isLoading('addTripType')}
                                >
                                    <option value="">Select {field.label}</option>
                                    {field.options.map((option, i) => (
                                        <option key={i} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                            ) : field.type === 'checkbox' ? (
                                <div className="form-group checkbox-group">
                                    <input
                                        type="checkbox"
                                        name={field.name}
                                        checked={!!formData[field.name]}
                                        onChange={handleChange}
                                        disabled={isLoading('addTripType')}
                                    />
                                    <label>{field.label}</label>
                                </div>
                            ) : (
                                <input
                                    type={field.type}
                                    name={field.name}
                                    required={field.required}
                                    onChange={handleChange}
                                    value={formData[field.name] || ''}
                                    disabled={isLoading('addTripType')}
                                />
                            )}
                        </div>
                    );
                })}
                <button type="submit">Submit</button>
            </form>
        </div>
    );
}

export default AddTripType;
